module.exports = __webpack_public_path__ + "static/media/userActiveIcon.6ae19428.svg";